export default {
	props: {
		result: {
			type: Object,
			required: true
		},
		imageDimensions: {
			type: Object,
			required: false,
			default: () => ({
				height: 37,
				width: 37
			})
		},
		pickOneImage: {
			type: Object,
			required: false,
			default: null
		},
		pickTwoImage: {
			type: Object,
			required: false,
			default: null
		},
		pickThreeImage: {
			type: Object,
			required: false,
			default: null
		},
		pickFourImage: {
			type: Object,
			required: false,
			default: null
		},
		pickFiveImage: {
			type: Object,
			required: false,
			default: null
		}
	}
};
